export default () => ({
  selectMenu: {
    padding: '6px 32px 7px 10px',
    fontSize: '.8em',
  },
  selectIcon: { color: 'white' },
  menuItemText: { padding: 0 },
  root: {
    marginRight: '1em',
    color: 'white',
  },
});
